import { Typography } from '@material-ui/core';
import { Box } from '@superdispatch/ui-lab';

interface DriverPreferencesBannerProps {
  text: string;
}

export function DriverPreferencesBanner({
  text,
}: DriverPreferencesBannerProps) {
  return (
    <Box padding="small" backgroundColor="Blue50">
      <Typography variant="caption">{text}</Typography>
    </Box>
  );
}
